export class UploadsModel {
    public id: any;
    public templateid: number;
    public recordname: string;
    public recordtemplate: string;
    public recorddesc: string;
    public columnname: string;
    public columntype: string;
    public templateheader: string;
    public columnorder: number;
    public status: string;
    public created_dt: Date;
    public created_by: string;
    public updated_by: string;
    public updated_dt: Date;
    
    constructor() {
        this.templateid = null;
        this.recordname = null;
        this.recordtemplate = null;
        this.recorddesc = null;
        this.columnname = null;
        this.columntype = null;
        this.templateheader = null;
        this.columnorder = null;
        this.status = null;
        this.created_dt = null;
        this.created_by = null;
        this.updated_by = null;
        this.updated_dt = null;
    }
}
